import React from "react";
import { useStyles } from "./styles";
import { RefButtonProps } from "./types";
import classNames from "classnames";
import AnchorLink from "react-anchor-link-smooth-scroll";

export const RefButton = (props: RefButtonProps) => {
  const classes = useStyles();

  return (
      !props.href?.includes("#") ? React.createElement(
          props.tag || 'a',
          {
              onClick: props.onClick,
              className: classNames(
                  classes.button,
                  `${props.classNames ? props.classNames : ""}`,
                  {
                      //Default
                      [classes.outlined]: props.outlined,

                      //Variants
                      [classes.primary]: props.variant === "primary",
                      [classes.secondary]: props.variant === "secondary",

                      //Sizes
                      [classes.xl]: props.size === "xl",
                      [classes.lg]: props.size === "lg",
                      [classes.md]: props.size === "md",
                      [classes.sm]: props.size === "sm",
                      [classes.xs]: props.size === "xs",

                      //Spin
                      [classes.spin]: props.spin
                  }
              ),
              href: props.href && props.tag !== "button" ? props.href : null,
              style: props.style,
              disabled: props.disabled && props.tag === "button",
              target: props.target && props.tag !== "button" ? props.target : null,
              type: props.tag === "button" ? props.type : null
          },
          props.text,
          props.children
      ) :
      <AnchorLink
          offset={props.offset}
          href={props.href}
          className={
              classNames(
                  classes.button,
                  `${props.classNames ? props.classNames : ""}`,
                  {
                      //Default
                      [classes.outlined]: props.outlined,

                      //Variants
                      [classes.primary]: props.variant === "primary",
                      [classes.secondary]: props.variant === "secondary",

                      //Sizes
                      [classes.xl]: props.size === "xl",
                      [classes.lg]: props.size === "lg",
                      [classes.md]: props.size === "md",
                      [classes.sm]: props.size === "sm",
                      [classes.xs]: props.size === "xs",
                  }
              )
          }
      >
          {props.text}
      </AnchorLink>
  );
};
